import React from "react";

const Java_Check_Anagram = () => {
  return (
    <div>
      <h1>Java Check Anagram</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Check Anagram in Java.</p>
    </div>
  );
};

export default Java_Check_Anagram;
